import { render } from "./OperationsOverview.vue?vue&type=template&id=b327d70e&scoped=true"
import script from "./OperationsOverview.vue?vue&type=script&lang=js"
export * from "./OperationsOverview.vue?vue&type=script&lang=js"

import "./OperationsOverview.vue?vue&type=style&index=0&id=b327d70e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b327d70e"]])

export default __exports__